import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './reference-material.reducer';

export const ReferenceMaterialDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const referenceMaterialEntity = useAppSelector(state => state.referenceMaterial.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="referenceMaterialDetailsHeading">
          <Translate contentKey="coconApp.referenceMaterial.detail.title">ReferenceMaterial</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{referenceMaterialEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="coconApp.referenceMaterial.name">Name</Translate>
            </span>
          </dt>
          <dd>{referenceMaterialEntity.name}</dd>
        </dl>
        <Button tag={Link} to="/reference-material" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/reference-material/${referenceMaterialEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ReferenceMaterialDetail;
